import { Component, OnInit, Output, EventEmitter, Input, ViewChildren, HostListener, QueryList } from '@angular/core';
import { RequestRoot, SearchOption } from 'types';
import { FeaturesImpl } from '../model/features-impl';
import { SearchFieldViewModel, SearchFieldComponent } from '../search-field/search-field.component';
import { MaskedDate } from '../model/features-decl';
import { AppContext } from '../control/context';

@Component({
  selector: 'i-requests-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent implements OnInit {
  private _statusesEnumType: any;
  constructor(private _appContext: AppContext) {
    this._statusesEnumType = Object.getPrototypeOf(this._appContext.getRequestStatusesEnumTemplate());
  }

  @Input() hotkeysEnabled: boolean = false;
  @Input() mode: 'Extended' | 'Basic' = 'Basic';
  @Input() template: any;

  @Output() searchEvent = new EventEmitter<any>();

  @ViewChildren('field') private _searchableFields: QueryList<SearchFieldComponent>;

  searchableFields: SearchFieldViewModel[] = [];
  status: SearchFieldViewModel = new SearchFieldViewModel();
  modifyDate: SearchFieldViewModel = new SearchFieldViewModel();
  statusChangeDate: SearchFieldViewModel = new SearchFieldViewModel();
  eventStatus: SearchFieldViewModel = new SearchFieldViewModel();
  eventStatusDate: SearchFieldViewModel = new SearchFieldViewModel();

  ngOnInit(): void {
    this.initSearchFieldsViewModels();

    const searchableColumns = FeaturesImpl.columns.filter((c) => c.searchable && c.rootPrototype === Object.getPrototypeOf(this.template));
    searchableColumns.forEach((c) => {
      const vm = new SearchFieldViewModel();
      vm.rootPrototype = c.rootPrototype;
      vm.targetPropertyPath = c.targetProperty;
      vm.fieldPrototype = FeaturesImpl.findPrototype(c.rootPrototype, this.template, c.targetProperty.split('.'));
      vm.i18nName = 'COLUMN.' + c.rootPrototype.constructor.name + '.' + c.targetProperty;
      vm.searchOption = SearchOption.Partial;
      vm.flex = FeaturesImpl.getColumnEditFlexStyle(this.template, c.targetProperty);
      vm.val = null;
      this.searchableFields.push(vm);
    });
  }

  private type(template: any): any {
    return Object.getPrototypeOf(template);
  }

  private initSearchFieldsViewModels(): void {
    this.status.targetPropertyPath = '.status';
    this.status.fieldPrototype = this._statusesEnumType;
    this.status.rootPrototype = this.type(new RequestRoot());
    this.status.i18nName = 'search.bar.field.status';
    this.status.searchOption = SearchOption.Exact;
    this.status.searchOptionSelectionVisible = false;
    this.status.enumRadioButtonsMode = false;

    this.eventStatus.targetPropertyPath = '.eventHistory[].type';
    this.eventStatus.fieldPrototype = this._statusesEnumType;
    this.eventStatus.rootPrototype = this.type(new RequestRoot());
    this.eventStatus.i18nName = 'search.bar.fields.event.type';
    this.eventStatus.searchOption = SearchOption.Exact;
    this.eventStatus.enumRadioButtonsMode = false;
    this.eventStatus.searchOptionSelectionVisible = false;

    this.eventStatusDate.targetPropertyPath = '.eventHistory[].created';
    this.eventStatusDate.fieldPrototype = this.type(new MaskedDate());
    this.eventStatusDate.rootPrototype = this.type(new RequestRoot());
    this.eventStatusDate.i18nName = 'search.bar.fields.event.created';
    this.eventStatusDate.searchOption = SearchOption.Interval;
    this.eventStatusDate.searchOptionSelectionVisible = false;
  }

  @HostListener('keyup.enter')
  onEnterKeyDown(): void {
    if (this.hotkeysEnabled) {
      this.apply();
    }
  }

  apply(): void {
    const searchFilter = this.searchableFields
      .concat(this.status, this.modifyDate, this.statusChangeDate, this.eventStatus, this.eventStatusDate)
      .filter((f) => f.val !== undefined && f.val !== null && f.val !== '')
      .map((f) => ({ fieldPath: f.targetPropertyPath + f.valuePath, value: f.val, option: f.searchOption }));
    this.searchEvent.emit(searchFilter);
  }

  clear(): void {
    this._searchableFields.forEach((f) => f.clear());
    this.apply();
  }
}
